import React from 'react';

const PERIOD_OPTIONS = [
  { value: 'hour', label: 'в час' },
  { value: 'day', label: 'в день' },
  { value: 'month', label: 'в месяц' }
];

const CURRENCY_OPTIONS = [
  { value: 'RUB', label: '₽' },
  { value: 'USD', label: '$' },
  { value: 'AED', label: 'د.إ' }
];

const SalaryInput = ({ value, onChange }) => {
  const period = value?.period || 'hour';

  const handleAmountChange = (e) => {
    const amount = e.target.value.replace(/[^0-9]/g, '');
    onChange({
      target: {
        name: 'salary',
        value: {
          ...value,
          amount: amount ? parseInt(amount) : ''
        }
      }
    });
  };

  const handlePeriodChange = (selectedPeriod) => {
    onChange({
      target: {
        name: 'salary',
        value: {
          ...value,
          period: selectedPeriod.value
        }
      }
    });
  };

  const handleCurrencyChange = (currency) => {
    onChange({
      target: {
        name: 'salary',
        value: {
          ...value,
          currency: currency.value
        }
      }
    });
  };

  return (
    <div className="salary-input">
      <div className="salary-field">
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: 0 }}>
          <div className="currency-selector">
            {CURRENCY_OPTIONS.map(option => (
              <button
                key={option.value}
                type="button"
                className={`currency-button${value?.currency === option.value || (!value?.currency && option.value === 'AED') ? ' active' : ''}`}
                onClick={() => handleCurrencyChange(option)}
                style={
                  value?.currency === option.value || (!value?.currency && option.value === 'AED')
                    ? { color: 'var(--tg-theme-button-text-color, #fff)' }
                    : {}
                }
              >{option.value}</button>
            ))}
          </div>
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            value={value?.amount || ''}
            onChange={handleAmountChange}
            placeholder="Сумма"
            className="amount-input"
            autoComplete="off"
            autoCorrect="off"
            spellCheck={false}
          />
        </div>
        <div className="period-selector">
          <div className="period-buttons">
            {PERIOD_OPTIONS.map(option => (
              <button
                key={option.value}
                type="button"
                className={`period-button${period === option.value ? ' active' : ''}`}
                onClick={() => handlePeriodChange(option)}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(SalaryInput); 